import React, { useEffect } from 'react';

function About() {
  useEffect(() => {
    // Redirect to pholtr.com
    window.location.href = 'https://pholtr.com';
  }, []);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      fontFamily: 'system-ui, -apple-system, sans-serif'
    }}>
      <p>Redirecting to pholtr.com...</p>
    </div>
  );
}

export default About;
